export const isMobile: boolean = (() => {
  const userAgent =
    typeof window.navigator === 'undefined' ? '' : window.navigator.userAgent

  return /Mobile|Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    userAgent
  )
})()
